import { duplicateCommentThread } from 'ckeditor5-custom-build/lib/ckeditorLib';
import { useState } from 'react';
import i18n from '../../../../../i18n';

type Props = {
  editor: any;
  threadId: string;
  setCommentCopyDialogIsOpen: (isOpen: boolean) => void;
  onCancel: () => void;
};

function CommentCopyPage({ editor, threadId, setCommentCopyDialogIsOpen, onCancel }: Props): JSX.Element {
  /* eslint-disable */
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState<boolean>(true);
  editor.editing.view.document.on('selectionChange', () => {
    const selection = editor.model.document.selection;
    setIsSubmitButtonDisabled(selection.isCollapsed);
  });
  /* eslint-enable */

  // Events
  const handleCancel = (): void => {
    onCancel();
  };

  const handleSubmit = (): void => {
    duplicateCommentThread(threadId, false);
    setCommentCopyDialogIsOpen(false);
  };

  return (
    <div>
      <div style={{ padding: '15px', marginBottom: '20px', backgroundColor: '#ffeeee', border: '5px solid #ee9999' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontSize: '1rem' }}>
          <i className="fa fa-exclamation-circle" style={{ marginRight: '3px', color: '#C21413' }} />
          <div style={{ color: '#C21413', fontWeight: 'bold' }}>{i18n.t('注意')}</div>
        </div>
        <div style={{ fontSize: '.8rem', lineHeight: '1rem' }}>
          <strong style={{ textDecoration: 'underline' }}>
            {i18n.t('コメントをコピーしても保存はされません。')}
            <br />
            {i18n.t('忘れず保存してください。')}
          </strong>
        </div>
      </div>
      <div style={{ marginBottom: '30px' }}>
        <div>{i18n.t('範囲を選択して変更ボタンを押してください。')}</div>
      </div>
      <div style={{ padding: '0', margin: '0 3px 0 3px', display: 'flex', gap: '15px' }}>
        <button
          type="button"
          className="cancelbtn"
          style={{ letterSpacing: '0', paddingRight: '12px', width: '100%' }}
          onClick={handleCancel}
        >
          {i18n.t('キャンセル')}
        </button>
        <input
          type="submit"
          style={{ letterSpacing: '0', paddingRight: '13px', width: '100%' }}
          value={i18n.t('コピー').toString()}
          className="searchbtn"
          disabled={isSubmitButtonDisabled}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}

export default CommentCopyPage;
